import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface MoveVDRFileRequest {
    engagementId: number;
    fileSourceType: VDRFileSourceType;
    vdrFileId?: number;
    sourceAnswerFileId?: number;
    sourceQuestionId?: number;
    sourceDataFormId?: number;
    sourceDataTableCellFileId?: number;
    sourceDataTableId?: number;
    destinationFolderPath: string;
}

export const MoveVDRFile = createAsyncThunk(
    'dataRoom/moveFile',
    async (
        {
            engagementId,
            fileSourceType,
            vdrFileId,
            sourceAnswerFileId,
            sourceQuestionId,
            sourceDataFormId,
            sourceDataTableCellFileId,
            sourceDataTableId,
            destinationFolderPath,
        }: MoveVDRFileRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.put(
                `api/VirtualDataRoomDocument/${engagementId}/file/move`,
                {
                    fileSourceType,
                    vdrFileId,
                    sourceAnswerFileId,
                    sourceQuestionId,
                    sourceDataFormId,
                    sourceDataTableCellFileId,
                    sourceDataTableId,
                    destinationFolderPath,
                }
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not move file at the moment.',
                    'error'
                );
                throw new Error('Failed to move file');
            }

            return response.data;
        } catch (error) {
            createNotification(
                'An error occurred while moving file.',
                'error'
            );
            throw error;
        }
    }
);
